module.exports = __webpack_public_path__ + "static/img/safari.ba09d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safari.png
// module id = iJka
// module chunks = 1